<a class="link-box" (click)="goTo()">
  <span>{{ text | translate }}</span>
  <span class="icon">
    <app-icon name="chevron_right_20_regular" class="primary"></app-icon>
  </span>
</a>
